export const getLocalToken = () => localStorage.getItem("token");

export const saveLocalToken = (token: string) => localStorage.setItem("token", token);

export const removeLocalToken = () => localStorage.removeItem("token");

export function buildInclusiveUtcDateRange(
  startDate: string,
  endDate: string,
): {
  startDate: string;
  endDate: string;
} {
  return {
    startDate: new Date(`${startDate}T00:00:00.000Z`).toISOString(),
    endDate: new Date(`${endDate}T23:59:59.999Z`).toISOString(),
  };
}
